/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progate_Description1Inputs */

const zh_progate_description1 = /** @type {(inputs: Progate_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此功能仅限 Pro 计划用户使用。升级后可解锁 PDF 导出、打印等更多功能。`)
};

const en_progate_description1 = /** @type {(inputs: Progate_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This feature is available on the Pro plan. Upgrade to unlock PDF export, printing, and more.`)
};

const es_progate_description1 = /** @type {(inputs: Progate_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta función está disponible en el plan Pro. Actualiza para desbloquear exportación PDF, impresión y más.`)
};

/**
* | output |
* | --- |
* | "This feature is available on the Pro plan. Upgrade to unlock PDF export, printing, and more." |
*
* @param {Progate_Description1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const progate_description1 = /** @type {((inputs?: Progate_Description1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progate_Description1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_progate_description1(inputs)
	if (locale === "en") return en_progate_description1(inputs)
	return es_progate_description1(inputs)
});
export { progate_description1 as "proGate_description" }